import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { pastelColour } from 'shared/utils/colors'

import styles from './Avatar.module.scss'

const renderPicture = ({
  name,
  initials,
  size,
  picture
}) => {
  const pictureClassName = classNames(
    styles.picture,
    size === 'large' && styles.largePicture,
    size === 'small' && styles.smallPicture,
    size === 'smaller' && styles.smallerPicture,
    size === 'tiny' && styles.tinyPicture
  )

  if(picture) {
    return <img
      className={pictureClassName}
      title={name}
      src={picture}
    />
  }

  return (
    <div className={pictureClassName}>
      <div
        title={name}
        className={styles.circle}
        style={{
          backgroundColor: pastelColour(initials)
        }}
      >
        <span
          className={classNames(
            styles.initials,
            size === 'small' && styles.smallInitials,
            size === 'smaller' && styles.smallerInitials,
            size === 'tiny' && styles.tinyInitials
          )}
        >
          {initials}
        </span>
      </div>
    </div>
  )
}

renderPicture.propTypes = {
  name: PropTypes.string,
  initials: PropTypes.string,
  size: PropTypes.string,
  picture: PropTypes.string
}

const Avatar = ({
  subject,
  size
}) => {
  const name = subject?.name || 'Unknown',
        initials = name.split(' ').map((n) => n[0]).join('').toUpperCase()

  return (
    <main
      className={styles.avatar}
      title={name}
    >
      {renderPicture({
        name,
        initials,
        size,
        picture: subject.picture
      })}
    </main>
  )
}

Avatar.propTypes = {
  subject: PropTypes.object.isRequired,
  size: PropTypes.string
}
Avatar.defaultProps = {
  size: 'small'
}

export default Avatar
